export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

export class LoggerService {
  private isDevelopment: boolean;
  private logLevel: LogLevel;

  constructor(logLevel: LogLevel = LogLevel.INFO) {
    this.isDevelopment = process.env.NODE_ENV === "development";
    this.logLevel = logLevel;
  }

  private formatMessage(level: string, message: any): string {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level}]`;

    if (this.isDevelopment) {
    }
    if (typeof message === "object") {
      return `${prefix} ${JSON.stringify(message)}`;
    }
    return `${prefix} ${message}`;
  }

  debug(...args: any[]): void {
    if (this.logLevel <= LogLevel.DEBUG) {
      const message = this.formatMessage("DEBUG", args);
      console.log(message);
    }
  }

  log(...args: any[]): void {
    if (this.logLevel <= LogLevel.INFO) {
      const message = this.formatMessage("INFO", args);
      console.log(message);
    }
  }

  warn(...args: any[]): void {
    if (this.logLevel <= LogLevel.WARN) {
      const message = this.formatMessage("WARN", args);
      console.warn(message);
    }
  }

  error(...args: any[]): void {
    if (this.logLevel <= LogLevel.ERROR) {
      const message = this.formatMessage("ERROR", args);
      const error = args.find((arg) => arg instanceof Error);

      if (error && error.stack) {
        console.error(message, "\n", error.stack);
      } else {
        console.error(message);
      }
    }
  }

  // private sendToLogService(level: string, message: string): void {
  //   if (!this.isDevelopment) {
  //   } else {
  //   }
  // }
}

export const loggerService = new LoggerService();
